// extracted by mini-css-extract-plugin
export default {"team":"Team_team__IVf+E","container":"Team_container__TiSmI","feature":"Team_feature__l5EzR","left":"Team_left__Z8IaX","right":"Team_right__RWh4f"};